<cs-header>
  <cs-header-title>{{ LL.customizeHomepage.title() }}</cs-header-title>
</cs-header>

<cs-content>
  <cs-card-list>

    <!-- Daily Log Section -->
    <cs-card>
      <cs-card-title>{{ LL.customizeHomepage.sections.dailyLog() }}</cs-card-title>
      <cs-card-content>
        <div class="toggle-list">
          <div class="toggle-row">
            <span class="toggle-label">{{ LL.customizeHomepage.options.wakeUp() }}</span>
            <cs-toggle [(checked)]="settings.showDayStartEvents"></cs-toggle>
          </div>
          <div class="toggle-row">
            <span class="toggle-label">{{ LL.customizeHomepage.options.weighIn() }}</span>
            <cs-toggle [(checked)]="settings.homepageShowWeighIn"></cs-toggle>
          </div>
          <div class="toggle-row">
            <span class="toggle-label">{{ LL.customizeHomepage.options.workout() }}</span>
            <cs-toggle [(checked)]="settings.homepageShowWorkout"></cs-toggle>
          </div>
          <div class="toggle-row">
            <span class="toggle-label">{{ LL.customizeHomepage.options.meals() }}</span>
            <cs-toggle [(checked)]="settings.homepageShowMeals"></cs-toggle>
          </div>
          <div class="toggle-row last">
            <span class="toggle-label">{{ LL.customizeHomepage.options.sleep() }}</span>
            <cs-toggle [(checked)]="settings.showDayEndEvents"></cs-toggle>
          </div>
        </div>
      </cs-card-content>
    </cs-card>

    <!-- Progress Section -->
    <cs-card>
      <cs-card-title>{{ LL.customizeHomepage.sections.progress() }}</cs-card-title>
      <cs-card-content>
        <div class="toggle-list">
          <div class="toggle-row">
            <span class="toggle-label">{{ LL.customizeHomepage.options.goal() }}</span>
            <cs-toggle [(checked)]="settings.homepageShowGoalCard"></cs-toggle>
          </div>
          <div class="toggle-row">
            <span class="toggle-label">{{ LL.customizeHomepage.options.bodyComposition() }}</span>
            <cs-toggle [(checked)]="settings.homepageShowBodyComposition"></cs-toggle>
          </div>
          <div class="toggle-row">
            <span class="toggle-label">{{ LL.customizeHomepage.options.nutrition() }}</span>
            <cs-toggle [(checked)]="settings.homepageShowNutritionChart"></cs-toggle>
          </div>
          <div class="toggle-row last">
            <span class="toggle-label">{{ LL.customizeHomepage.options.coachingTips() }}</span>
            <cs-toggle [(checked)]="settings.homepageShowCoachingTips"></cs-toggle>
          </div>
        </div>
      </cs-card-content>
    </cs-card>

  </cs-card-list>
</cs-content>
